<template>
  <div class="form-step">
    <div class="row align-items-center wrapper-steps-example">
      <div class="col-10">
        <div class="descriptionText" v-html="$t(texts.descriptionText)"></div>
        <ul style="list-style-type: disc;">
          <li :key="step.label" v-for="step in steps">
            {{ $t(step.text) }}
          </li>
        </ul>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="inner-form-block serial-numbers-block w-100">
        <checkboxTerms
          v-if="isCheckboxTerms"
          selectionComponentId="a32gsd"
          class="mt-25"
          fieldId="checkbox-terms"
          name="terms"
          ref="terms"
          :specific-terms="true"
        />
        <!-- <input
          type="hidden"
          v-model="modelNumbers"
        > -->

        <div class="col-12">
          <!-- <div class="model-number-wrapper">
            <input class="model-number-field" type="text" :value="number" disabled>
            <select
              v-model="particularNumber(number).qty"
              name="qty"
              class="quantity-select"
              id="qty"
              @change="selectQuantity(particularNumber(number).qty, number)">
              <option
                v-for="option in 1"
                :key="option"
                :value="option">
                {{ option }}
              </option>
            </select>
            <span class="remove-btn" @click="removeItem(particularNumber(number))" v-if="modelNumbers.length > 1" title="Remove">✕</span>
          </div> -->
          <div style="display: flex;flex-direction: column">
            <!-- <div class="model-label">{{$t('Serial Number')}}</div> -->
            <ValidationObserver ref="gtin-form" id="gtin-form">
              <ValidationProvider
                name="modelNumber"
                :rules="`required`"
                v-slot="{ errors }"
              >
                <v-select
                  v-if="options.length > 0"
                  class="model-select col-12"
                  :options="options"
                  v-model="modelNumber"
                  :class="{'invalid-model': errors.length}"
                  :placeholder="$t('Choose model number') + '*'"
                  value=""
                  @input="clearFields"
                  :clearable="false"
                />
                <div class="validation-error" style="margin: 0 0 15px 15px;" v-if="errors.length">{{errors[0]}}</div>
              </ValidationProvider>
              <ValidationProvider
                v-if="serialNumberRequired"
                :name="$t('Serial Number')"
                :rules="`required|alpha_num|length:14`"
                v-slot="{ errors }"
              >
                <input
                  v-model="serial"
                  class="serial-number-input w-100"
                  :class="{'is-invalid': errors.length}"
                  type="text"
                  :placeholder="$t('Enter serial number') + '*'"
                  @change="checkSerialNumber(serial, errors)"
                  :disabled="!modelNumber"
                  required
                  maxlength=14
                >
                <div class="validation-error" v-if="errors.length">{{errors[0]}}</div>
              </ValidationProvider>
            </ValidationObserver>
            <img src="/assets/images/barcode.png" style="width: 100%;max-width: 550px; margin: 0;display:block;" :alt="$t('Model Number')">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import checkboxTerms from "./checkbox-terms";
import { mapFields } from '../../store/helpers'
import vSelect from "vue-select";

export default {
  name: 'gtin-component',
  components: {
    vSelect,
    checkboxTerms
  },
  props: {
    fieldId : {
      type: String
    },
    texts: {
      type: Object,
      default () {
        return {}
      }
    },
    options: {
      type: Array,
      required: true
    },
    isCheckboxTerms: {
      type: Boolean,
      default: false
    },
    buttonStyles: {
      type: Object,
      default: () => {
        return {
          'background-color': '#1B578E;',
          'border-radius': '8px;',
          'min-height': '60px;',
          'margin': '40px 0 0;'
        }
      }
    },
    serialNumberRequired: {
      type: Boolean,
      default: true
    },
    steps: {
      required: false,
      type: [Array, Object],
      default: () => []
    }
  },
  data () {
    return {
      serialsFilled: false,
      serialErrors: [],
      termsChecked: false,
      totalSerialNumber: 0
    }
  },
  mounted () {
    this.$eventHub.$on('checkGTIN-event', this.checkGTIN)
    this.$eventHub.$on('checkbox-event', this.checkTerms)
  },
  beforeDestroy () {
    this.$eventHub.$off('checkGTIN-event', this.checkGTIN)
    this.$eventHub.$off('checkbox-event', this.checkTerms)
  },
  computed: {
    ...mapFields([
      'serial',
      'modelNumber',
      'selectedQuantity'
    ]),
    hasModelNumbers () {
      return this.modelNumbers.filter(item => item)
        .length > 0
    }
  },
  methods: {
    checkGTIN () {
      this.$refs['gtin-form'].validate()
      this.scrollTo(`[id=${this.fieldId}`);
    },
    // checkTerms (e) {
    //   this.termsChecked = Boolean(Number(e.checked))
    // },
    // checkSerials (errors = []) {
    /**
         * Checks if every serial field from every model number is equal to 14.
         */
    // const isEqualForteen = (currentValue) => currentValue.code.length === 14;
    // if(this.totalSerialNumber < 6) {
    //   Object.values(this.serials).filter(k => {
    //     this.serialsFilled = k.every(isEqualForteen)
    //   })
    // }
    //   this.serialErrors = errors;
    //   this.checkSerialNumber();
    // },
    // particularNumber (id) {
    //   return this.selectedQuantity.find(el => el.id === id);
    // }
    // selectQuantity (qty, id = '') {
    //   if (!this.selectedQuantity.find(el => el.id === id)) {
    //     this.totalSerialNumber = this.totalSerialNumber + qty;
    //     this.selectedQuantity.push({ id, qty });
    //   } else {
    //     if(this.serials[id].length > qty){
    //       this.totalSerialNumber = this.totalSerialNumber - Math.abs(this.serials[id].length - qty);
    //     }else{
    //       this.totalSerialNumber = this.totalSerialNumber + Math.abs(this.serials[id].length - qty);
    //     }
    //     this.selectedQuantity.find(el => el.id === id).qty = qty;
    //   }

    //   if(this.totalSerialNumber > 0) {
    //     this.showModal(this.$t(this.texts.serialNumberRestrictionMessage));
    //   }

    //   this.serials[id] = [];
    //   for(let i = 1; i <= qty; i++) {
    //     this.serials[id].push({
    //       id: `${id}-${i}`,
    //       code: ''
    //     })
    //   }
    //   this.checkSerials();
    // },
    // selectModelNumber (e) {
    //   if (this.modelNumbers.length > 1) {
    //     this.showModal(this.$t(this.texts.serialNumberRestrictionMessage));
    //     return
    //   }
    //   this.modelNumbers.push(e);
    //   const index = this.options.findIndex(el => el === e);
    //   this.options.splice(index, 1);
    //   this.selectQuantity(1, e);
    // },
    // removeItem (number) {
    //   const index = this.modelNumbers.findIndex(el => el === number.id);
    //   this.modelNumbers.splice(index, 1);
    //   this.options.push(number.id);

    //   this.totalSerialNumber = this.totalSerialNumber - this.serials[number.id].length;
    //   delete this.serials[number.id];

    //   this.checkSerials();
    // },
    clearFields () {
      this.serial = ''
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: this.modelNumber != ''
      });
      return
    },
    checkSerialNumber (serial, errors) {
    //   if(this.serialsFilled){
    //     let serialsArray = [];
    //     Object.keys(this.serials).forEach((key)=>{
    //       this.serials[key].forEach((element) => {
    //         let obj = {
    //           "modelNumber": key,
    //           "serialNumber": element.code
    //         };
    //         serialsArray.push(obj)
    //         // this.$store.dispatch("sendSerialNumber", {
    //         //   serials: serialsArray
    //         // }).then(r => {
    //         //   console.log("Response:", r)
    //         // });
    //       })
    //     });
    //     this.$store.commit('setSerialsArray', serialsArray)
    //   }
      if (errors.length > 0) {
        this.serial = ''
        this.$store.dispatch("setComponentStatus", {
          component: this.fieldId,
          status: this.serial.length > 0
        });
        return;
      }
      this.$store.commit('setSerial', this.serial)
      this.$store.commit('setModelNumber', this.modelNumber)
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: this.serial.length > 0
      });
    }
  }
}
</script>

<style scoped lang="scss">
  .model-label {
    font-size: 10px;
  }
  .remove-btn {
    position: absolute;
    top: 0;
    margin: auto;
    font-size: 22px;
    right: -22px;
    cursor: pointer;
    color: #ee7d1a;

    @media (max-width: 767px) {
      right: 10px;
    }
  }

  .serial-numbers-block {
    .form-control.is-invalid {
      background-image: none;
    }
    @media (max-width: 768px) {
      img {
        width: 100%;
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .model-number-wrapper {
    display: flex;
    position: relative;
    margin-bottom: 5px;
  }
  .model-number-field {
    margin-right: auto;
    width: calc(100% - 40px)
  }

  .quantity-select {
    border-color: rgba(118, 118, 118, 0.3);
    border-radius: 8px;
  }

  .serial-number-input {
    border: 1px solid rgba(60,60,60,.26);
    padding: 0 5px;
    border-radius: 4px;
    margin-bottom: 5px;
    font-size: 12px;
    height: 30px;
    text-transform: uppercase;
  }
  li::marker {
    color: var(--primary-color-3);
    font-size: 1.2em;
  }
  .descriptionText {
    margin-left: 20px;
    margin-bottom: 10px;
    font-size: 15px;
    line-height: 27px;
    font-weight: bold;
  }
  /deep/ .model-select .vs__dropdown-toggle {
    border: 1px solid var(--primary-color-1);
    border-radius: 2px;
    margin-bottom: 30px;
  }
  /deep/ .invalid-model .vs__dropdown-toggle {
    border-color: #dc3545 !important;
    background-color: #fff0f1 !important;
  }
</style>
